import React from 'react';

import {RegistrationScreen} from 'features/auth';

const RegistrationPage: React.FC = () => <RegistrationScreen />;

export default RegistrationPage;
